// Quadrant defaults applied at first-load (lazy migration). Nothing is
// written to Firestore until the user actually customizes their layout
// in the Phase 4 edit UI; until then `loadLayout` returns the result of
// `getDefaultLayoutForUser` instead.
//
// Tile ids reference TILE_REGISTRY entries. Unknown ids render as empty
// slots in the future quadrant -- so layouts can declare INTENT for a
// tile that doesn't exist yet (e.g. "myTime") and the slot auto-fills
// when that tile gets built later.
//
// Slot semantics: "" (empty string) means "intentionally empty"; the
// future edit UI will render an "+ Add tile" placeholder there.

export const LAYOUT_VERSION = 1;

export const DEFAULT_LAYOUT_BY_DEPT = {
  admin: {
    version: LAYOUT_VERSION,
    quadrants: {
      topLeft: "jobs",
      topRight: "serviceTickets",
      bottomLeft: "pmDueSoon",
      bottomRight: "invoices",
    },
  },
  billing: {
    version: LAYOUT_VERSION,
    quadrants: {
      // Closed Jobs (awaiting bill) replaces Quotes here — billing's
      // primary work queue is "convert closed jobs into invoices,"
      // not "track open quotes." Quotes still lives in the sidebar.
      topLeft: "invoices",
      topRight: "closedJobs",
      bottomLeft: "margin",
      bottomRight: "vendors",
    },
  },
  dispatch: {
    version: LAYOUT_VERSION,
    quadrants: {
      topLeft: "jobs",
      topRight: "serviceTickets",
      bottomLeft: "pmDueSoon",
      bottomRight: "messages",
    },
  },
  service: {
    version: LAYOUT_VERSION,
    quadrants: {
      topLeft: "jobs",
      topRight: "serviceTickets",
      bottomLeft: "pmDueSoon",
      bottomRight: "pmOverdue",
    },
  },
  field_tech: {
    version: LAYOUT_VERSION,
    quadrants: {
      topLeft: "jobs",
      topRight: "serviceTickets",
      bottomLeft: "messages",
      // Field-tech 4th slot: declared intent for "myTime" (current pay
      // period pie: straight / OT / DT). Tile gets built before Phase 3
      // renders the quadrant; until then, unknown id renders empty.
      bottomRight: "myTime",
    },
  },
};

// Resolve the right default for a given user. Admin role bypasses dept
// (admins have no department per [[project-departments-as-capability-presets]]).
// Legacy users with no dept fall back to the service preset -- the most
// neutral catchall for an unspecified contractor user.
export function getDefaultLayoutForUser(role, department) {
  if (role === "admin") return DEFAULT_LAYOUT_BY_DEPT.admin;
  const key = department && DEFAULT_LAYOUT_BY_DEPT[department]
    ? department
    : "service";
  return DEFAULT_LAYOUT_BY_DEPT[key];
}
